export const NOTIFICATION_LIMIT_DEFAULT = 10;
